<!--
 * @Description: 
 * @Date: 2020-11-10 16:47:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:37:48
-->
<template>
  <div class="custom-pie">
    <div
      class="custom-pie-item"
      v-for="(item, index) in dealSeries0data"
      :key="index"
    >
      <svg class="svg" width="200" height="200" viewport="0 0 200 200">
        <!-- <defs>
        <filter id="f1" x="0" y="0" width="200%" height="200%">
          <feOffset result="offOut" in="SourceGraphic" dx="10" dy="10" />
          <feColorMatrix
            result="matrixOut"
            in="offOut"
            type="matrix"
            values="0 0 0 0 0.76953125 0 0 0 0 0.76953125 0 0 0 0 0.76953125 0 0 0 1 0"
          />
          <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="5" />
          <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
        </filter>
        </defs>-->
        <path
          :d="d(item.value)['d'][1]"
          :fill="d(item.value)['is360'] ? 'none' : colorArr[index % 6](0.4)"
          :stroke="colorArr[index % 6](0.4)"
          :stroke-width="d(item.value)['is360'] ? 20 : 0"
          class="path-1"
        />
        <path
          :d="d(item.value)['d'][0]"
          :fill="d(item.value)['is360'] ? 'none' : colorArr[index % 6]()"
          :stroke="colorArr[index % 6]()"
          :stroke-width="d(item.value)['is360'] ? 20 : 0"
        />
        <path
          d="M55 95 A40 40 0 0 1 135 95 A40 40 0 0 1 55 95"
          stroke="#C6CCD3"
          stroke-width="1"
          fill="none"
          stroke-dasharray="4 2"
        />
        <!-- <path :d="d(item.value)[2]" :fill="#2722FF" /> -->
      </svg>
      <p class="p p-1">{{ getName(item) }}</p>
      <p class="p p-2">{{ getB(index) }}</p>
    </div>
  </div>
</template>

<script>
import { colorArr } from '../color/config.js';
export default {
  props: {
    series0data: {
      type: Array,
      default: () => []
    },
    finalDataCount: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: '单'
    },
    table: {
      type: Object,
      default() {
        return { data: [] };
      }
    }
  },
  data() {
    return { colorArr };
  },
  methods: {
    getPathD(deg1, deg2) {
      const d90 = Math.abs(deg2 - deg1) >= 180;
      const dis = 20;
      const r1 = 75;
      const r2 = 55;
      const degForSin = Math.sin((Math.PI * deg1) / 180);
      const degForCos = Math.cos((Math.PI * deg1) / 180);
      const point1 = [r1 - r1 * degForCos + dis, r1 - r1 * degForSin + dis];
      const point2 = [r1 - r2 * degForCos + dis, r1 - r2 * degForSin + dis];

      const degForSinEnd = Math.sin((Math.PI * deg2) / 180);
      const degForCosEnd = Math.cos((Math.PI * deg2) / 180);
      const point1End = [
        r1 - r1 * degForCosEnd + dis,
        r1 - r1 * degForSinEnd + dis
      ];
      const point2End = [
        r1 - r2 * degForCosEnd + dis,
        r1 - r2 * degForSinEnd + dis
      ];
      if (deg2 - deg1 == 360) {
        // 绘制整圆环
        return 'M30 95 A40 40 0 0 1 160 95 A40 40 0 0 1 30 95';
      }
      return `M${point1[0]} ${point1[1]} A${r1} ${r1} 0 ${d90 ? 1 : 0} 1 ${
        point1End[0]
      } ${point1End[1]} L${point2End[0]} ${point2End[1]} A${r2} ${r2} 0 ${
        d90 ? 1 : 0
      } 0 ${point2[0]} ${point2[1]} z`;
    },
    d(value) {
      const total = this.finalDataCount;
      const deg = Math.min((360 * value) / total, 360);
      const distance = 0;
      return {
        d: [
          this.getPathD(0, Math.max(deg - distance, 0)),
          this.getPathD(0, Math.max(deg - distance, 0))
        ],
        is360: deg == 360
      };
    }
  },
  computed: {
    getName() {
      return item => {
        if (`${item['b']}`.indexOf('%') > -1) {
          return item['name'];
        } else {
          return `${item['name']}：${item['b']}`;
        }
      };
    },
    getB() {
      return index => {
        const { dealSeries0data, table } = this;
        let obj = dealSeries0data[index];
        try {
          obj = table['data'][index] || obj;
        } catch (err) {
          console.error(err);
        }
        return obj['b'] + (`${obj['b']}`.indexOf('%') > -1 ? '' : '%');
      };
    },
    dealSeries0data() {
      return this.series0data;
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.custom-pie {
  display: flex;
  justify-content: space-around;
  &-item {
    .p {
      transform: translateY(-10px);
      &-1 {
        font-size: 14px;
        color: #434343;
        line-height: 1;
      }
      &-2 {
        font-size: 24px;
        color: #434343;
        line-height: 1;
        margin-top: 22px;
      }
    }
  }
}
.svg {
  transform: rotate(25deg);
  path {
    transition: all 0.3s;
  }
  .path-1 {
    transform: translate(4px, 2px);
  }
  .path-2 {
    transform: translate(0px, 5px);
  }
}
</style>
